export default __webpack_public_path__ + "static/media/enfermeiros_inicio.a14ec2ca.png";